export default __webpack_public_path__ + "static/media/sidebar-info.74594fab.svg";